var _rect, _path, _circle, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBgV2 = function SvgBgV2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1499,
    viewBox: "0 0 1440 1499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1499,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M691.678 0C681.038 51.9354 635.081 91 579.999 91C524.918 91 478.96 51.9354 468.32 0H691.678Z",
    fill: "#9B51E0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 858.5,
    cy: 829.5,
    r: 289.5,
    fill: "#F9B233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M738.373 0H1440V214.898C1365.36 293.785 1259.68 343 1142.5 343C938.983 343 770.141 194.534 738.373 0Z",
    fill: "#FE5F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 725.075C1348.96 711.982 1279 633.661 1279 538.999C1279 444.338 1348.96 366.017 1440 352.924V725.075Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.5 916C391.709 916 614 693.709 614 419.5C614 243.023 521.927 88.0507 383.197 0H0V902.014C37.6697 911.155 77.0191 916 117.5 916Z",
    fill: "#008FF5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBgV2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg_v2.daae3249f5d8e5180611c55e17239024.svg";